<template>
  <div
    class="dropdown relative border-2 shadow-md bg-white border-primary-500 text-gray-800 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text"
    style="border-radius: 1rem"
    v-on:mouseleave="nested.hide.value = true"
    v-on:mouseover="nested.hide.value = false"
  >
    <button class="px-1 py-1 items-center focus:outline-none text-xl flex" :style="{ width: width }">
      <span :class="'text-base whitespace-nowrap'" :style="{ width: textWidth }">
        {{ itemList[selectedIndex] }}
      </span>
      <svg class="fill-current" style="width: 1rem" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
      </svg>
    </button>
    <Transition name="slide-fade">
      <ul
        v-show="!nested.hide.value"
        class="dropdown-menu absolute hidden shadow-xl z-10"
        style="top: 2.1rem; border-radius: 1rem"
        :style="{ width: '7rem' }"
      >
        <li v-for="(value, index) in itemList" :key="index" class="rounded" :style="{ width: '7rem' }">
          <button
            class="py-1 px-3 text-base w-full block whitespace-no-wrap text-left focus:outline-none border-l border-r bg-white hover:bg-primary-50 text-gray-800 dark:bg-dark-200 dark:text-dark-text dark:hover:bg-dark-10 dark:border-dark-200"
            :class="{
              'list-round-first border-t': index == 0,
              'list-round-last border-b': index == itemList.length - 1
            }"
            v-on:click="click(index)"
          >
            {{ value }}
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    itemList: {
      type: Array,
      required: true
    },
    selectedIndex: {
      type: Number,
      required: true
    },
    selected: {
      type: Function,
      required: true
    },
    width: {
      type: String,
      default: '7rem'
    },
    textWidth: {
      type: String,
      default: '5.8rem'
    }
  },
  setup(props) {
    const click = (index: number) => {
      const value = props.itemList[index]
      props.selected(index, value)
      hide.value = true
    }

    const hide = ref(true)

    return { click, nested: { hide } }
  }
})
</script>

<style lang="postcss" scoped>
.triangle {
  &::before {
    @apply absolute;
    right: 0.2rem;
    top: 0.6rem;
    border-right: 0.3rem solid transparent;
    border-top: 0.3rem solid;
    border-left: 0.3rem solid transparent;
    content: '';
  }
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.selector-margin-top {
  margin-top: 2px;
}
</style>
